// extracted by mini-css-extract-plugin
export var active = "_2d-9";
export var backButton = "_2d-8";
export var clone = "_2d-e";
export var collapseBar = "_2d-j";
export var collapseMode = "_2d-l";
export var collapsed = "_2d-n";
export var dragHandle = "_2d-c";
export var dropdownIcon = "_2d-g";
export var expanding = "_2d-m";
export var hidden = "_2d-w";
export var iconContainer = "_2d-p";
export var iconSwapper = "_2d-v";
export var navItem = "_2d-6";
export var navItemIcon = "_2d-f";
export var navProfile = "_2d-7";
export var notificationCountBadge = "_2d-i";
export var notificationDot = "_2d-q";
export var optionsContainer = "_2d-h";
export var primaryNav = "_2d-0";
export var primaryNavDivider = "_2d-u";
export var primaryNavResizeHandle = "_2d-2";
export var primaryNavResizing = "_2d-1";
export var primaryNavTabSection = "_2d-t";
export var primaryTab = "_2d-o";
export var primaryTabIconBox = "_2d-r";
export var secondaryNav = "_2d-3";
export var selected = "_2d-s";
export var settingsNav = "_2d-4";
export var settingsNavItems = "_2d-5";
export var show = "_2d-d";
export var sideNav = "_2d-k";
export var teamItem = "_2d-a";
export var userProfileItem = "_2d-b";